interface ContactData {
  text: string;
  email: string;
  emailText: string;
}

export const contact: ContactData = {
  text:
    "If you have additional questions that aren't answered on the website or would just like to send us a note, \
    we'd love to hear from you!",
  email: 'questions@bri-and-matt.com',
  emailText: 'Email us',
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data/contact.ts